export default __webpack_public_path__ + "static/media/iconOutboundForm.7336fa1a.svg";